export class VoucherSKUValueDTO {
    constructor(
        public id: string,
        public skuId: string,
        public amount: number,
        public dateCreated: string,
        public dateUpdated: string
    ) { }
}
